module.exports = "/next-static/_next/static/images/hero_image_small-f783ddde5b103d102cc41529a2003a6f.png";